function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var HudPopupTemplate = require('./overlays/welcome.template');
var HudPopup = /*#__PURE__*/function () {
  function HudPopup(app, mod) {
    _classCallCheck(this, HudPopup);
    this.app = app;
    this.mod = mod;
    this.visible = false;
  }
  return _createClass(HudPopup, [{
    key: "render",
    value: function render() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var his_self = this.mod;
      var title = '';
      if (obj.title) {
        title = obj.title;
      }
      var text = '';
      if (obj.text) {
        text = obj.text;
      }
      if (title === text) {
        text = '';
      }
      var img = '';
      if (obj.img) {
        img = obj.img;
      }
      var card = '';
      if (obj.card) {
        card = obj.card;
      }
      var styles = '';
      if (obj.styles) {
        for (var z = 0; z < obj.styles.length; z++) {
          var css_key = String(obj.styles[z].key).replace(/[A-Z]/g, function (m) {
            return '-' + m.toLowerCase();
          });
          styles += "".concat(css_key, ":").concat(obj.styles[z].val, ";");
        }
      }
      var html = '';
      if (title != '') {
        title = "<div class=\"welcome-title\">".concat(title, "</div>");
      }
      if (text != '') {
        text = "<div class=\"welcome-text\">".concat(text, "</div>");
      }
      if (img != '') {
        html = "\n\t\t    <div class=\"welcome \" style=\"display: block; ".concat(styles, "; background-image: url(").concat(img, ");\" >\n\t\t      ").concat(title, "\n\t\t      ").concat(text, "\n\t\t    </div>\n\t\t  ");
      } else {
        html = "\n\t\t    <div class=\"welcome \" style=\"display: block; ".concat(styles, "; \" >\n\t\t      ").concat(title, "\n\t\t      ").concat(text, "\n\t\t    </div>\n\t\t  ");
      }
      his_self.hud.showPopup(html, 5000);
    }
  }, {
    key: "remove",
    value: function remove() {
      this.mod.hud.hidePopup();
    }
  }, {
    key: "hide",
    value: function hide() {
      this.mod.hud.hidePopup();
    }
  }]);
}();
module.exports = HudPopup;